export default {
  'budgets.page.button.blankBudget': 'Orçamento em Branco',
  'budgets.page.button.blankChecklist': 'Checklist em Branco',
  'budgets.page.button.importBudget': 'Importar Orçamento',
  'budgets.list.header.company': 'Company',
  'budgets.list.header.budget': 'Budget',
  'budgets.list.header.client': 'Client',
  'budgets.list.header.insuranceCompany': 'Insurance Company',
  'budgets.list.header.plate': 'Plate',
  'budgets.list.header.situation': 'Situation',
  'budgets.list.header.type': 'Type',
};
